"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var o = require('styled-components');
var react = require('react');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var o__default = /*#__PURE__*/_interopDefaultLegacy(o);

var x=o.css`
  gap: 0;
`,m=o.css`
  gap: var(--spacing-x-small, 4px);
`,$=o.css`
  gap: var(--spacing-small, 8px);
`,f=o.css`
  gap: var(--spacing-regular, 16px);
`,y=o.css`
  gap: var(--spacing-large, 24px);
`,S=o.css`
  gap: var(--spacing-x-large, 32px);
`,A=o.css`
  gap: var(--spacing-x-x-large, 48px);
`,u=o.css`
  gap: var(--spacing-x-x-x-large, 64px);
`,n=o__default["default"].div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large, 24px);

  ${a=>a.$xAlign&&{"align-items":a.$xAlign}}
  ${a=>a.$yAlign&&{"justify-content":a.$yAlign}}

  ${a=>a.$spacing==="none"&&x}
  ${a=>a.$spacing==="x-small"&&m}
  ${a=>a.$spacing==="small"&&$}
  ${a=>a.$spacing==="regular"&&f}
  ${a=>a.$spacing==="large"&&y}
  ${a=>a.$spacing==="x-large"&&S}
  ${a=>a.$spacing==="x-x-large"&&A}
  ${a=>a.$spacing==="x-x-x-large"&&u}
`;var r=react.forwardRef(function({spacing:p="large",xAlign:i,yAlign:l,className:t,children:c,...s},e){return jsxRuntime.jsx(n,{ref:e,$spacing:p,$xAlign:i,$yAlign:l,className:t,...s,children:c})});r.displayName="Stack";var v=o__default["default"](r)``;

exports.a = v;
